var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsEvidence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1594_108)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30321 11.0566H0V22.3774H15.4037V13.0944H8.71714V11.6033L9.26381 11.0566H8.71714V11.6033L8.16485 12.1556L7.68453 11.6753L8.30321 11.0566ZM6.18183 18.8358C6.11056 19.0093 6.19345 19.2077 6.36695 19.2789C6.54045 19.3502 6.73888 19.2673 6.81014 19.0938L8.68633 14.5257C8.75758 14.3522 8.67471 14.1538 8.50119 14.0825C8.32768 14.0113 8.12928 14.0942 8.058 14.2677L6.18183 18.8358ZM5.50838 18.4598C5.39144 18.6065 5.17777 18.6306 5.0311 18.5136L3.15697 17.0195C3.07648 16.9553 3.02943 16.8581 3.02905 16.7552C3.02869 16.6523 3.07499 16.5547 3.15498 16.4899L5.10365 14.9125C5.24943 14.7944 5.46328 14.817 5.58131 14.9628C5.69932 15.1085 5.67682 15.3224 5.53103 15.4404L3.91094 16.7519L5.45454 17.9825C5.60119 18.0995 5.62531 18.3132 5.50838 18.4598ZM9.5971 18.4598C9.71402 18.6065 9.92771 18.6306 10.0744 18.5136L11.9485 17.0195C12.029 16.9553 12.076 16.8581 12.0764 16.7552C12.0768 16.6523 12.0305 16.5547 11.9505 16.4899L10.0018 14.9125C9.85605 14.7944 9.64218 14.817 9.52417 14.9628C9.40617 15.1085 9.42867 15.3224 9.57446 15.4404L11.1945 16.7519L9.65094 17.9825C9.50427 18.0995 9.48018 18.3132 9.5971 18.4598Z",
    fill: "#3CDBC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71667 2H24.1129V12.3876L18.6927 6.96739C18.5642 6.83894 18.3574 6.83432 18.2233 6.95691L16.4795 8.55128L13.8555 5.97931C13.7225 5.84894 13.5093 5.85001 13.3776 5.98169L8.71667 10.6426V2ZM8.71667 11.0566V10.6426L8.30273 11.0566H8.71667ZM9.26334 11.0566L13.6201 6.69974L16.2336 9.2614L16.235 9.26267L18.1029 11.074L18.5758 10.5864L16.9667 9.02614L18.442 7.67734L23.8591 13.0943H15.4032V11.0566H9.26334ZM23.8591 13.0943L24.3255 13.5609L24.8059 13.0806L24.1129 12.3876V13.0943H23.8591ZM21.6223 6.30189C22.3726 6.30189 22.9808 5.69367 22.9808 4.9434C22.9808 4.19312 22.3726 3.58491 21.6223 3.58491C20.8721 3.58491 20.2638 4.19312 20.2638 4.9434C20.2638 5.69367 20.8721 6.30189 21.6223 6.30189Z",
    fill: "#3CDBC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1594_108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEvidence);
export default __webpack_public_path__ + "static/media/icons_evidence.13e3a8bc.svg";
export { ForwardRef as ReactComponent };